<template>
<div>
  <!-- <v-app> -->
    <div>
      <div class="sidebar">
        <sidebar />
      </div>
      <div class="main-body">
        <main-view 
          v-if="!loading"
        />
      </div>
    </div>
    <!-- <core-filter /> -->

    <!-- <core-toolbar
      v-if="!isCommonMenus"
    /> -->

    <!-- <core-drawer /> -->

    <!-- <main-view 
      v-if="!loading"
    /> -->
    <settings
    />
    </div>
  <!-- </v-app> -->
</template>

<script>
  import utils from '@/services/utils.js'
  import api from '@/services/api'
  import constants from '@/constants'
  import MainView from '@/views/View.vue'
  import Settings from './settings/Index.vue'
  import Sidebar from './Sidebar.vue'
  export default {
    components: {
      MainView,
      Settings,
      Sidebar
    },
    data () {
      return {
        loading: true,
      }
    },
    computed: {
      isCommonMenus () {
        // para saber si son menús comunes entre empresas
        return this.$route.path.indexOf('/common-menus') >= 0
      },
    },
    mounted (){
      this.getUserInfo()
      // this.getEnterpriseInfo()
    },
    methods: {
      getEnterpriseInfo (enterprises, enterpriseDefault) {
        let enterpriseID = ''
        // console.log(utils.getEnterpiseID(), enterprises, enterpriseDefault)
          // (solo si no es administrador) si tiene empresa en el store revisamos que esté en las empresas del usuario
          // para evitar los cambios de usuarios
        if (!this.$store.state.app.enterpriseID || (!this.$store.state.app.isAdmin && enterprises.indexOf(this.$store.state.app.enterpriseID) < 0)) {
          // console.log('1')
          // si no tiene una empresa en el store revisamos si esta en el localStorage
          if (utils.getEnterpiseID() && (this.$store.state.app.isAdmin || enterprises.indexOf(utils.getEnterpiseID()) >= 0)) {
            // console.log('2---------',this.$store.state.app.isAdmin, enterprises)
            // si es administrador o la empresa guardada en localStorage esta conectada con el usuario lo buscamos en la api y la activamos
            enterpriseID = utils.getEnterpiseID()
          } else if (enterprises.length > 0) {
            // console.log('3')
            // si enterpriseDefault se encuentra dentro de las activas activamos esta si no la primera de las empresas asociadas
            if (enterpriseDefault && enterprises.indexOf(enterpriseDefault) > 0) {
              // console.log('4')
              enterpriseID = enterpriseDefault
            } else {
              // console.log('5')
              enterpriseID = enterprises[0]
            }
          } else {
            // console.log('6')
            // no tiene empresas asociadas
          }
          if (enterpriseID && enterpriseID.length > 0) { 
            // console.log('7')
            api.getItem('enterprises', true, enterpriseID).then(response => {
              utils.setActiveEnterprise(this, response)
            })
          }
        } else {
          this.$router.push('/dashboard')
        }
        
        // console.log('aaa', utils.getUserID())
        // if (!this.$store.state.app.enterpriseID) {
        //   if (utils.getEnterpiseID()) {
        //     // TODO peniente de revisar
        //     api.getItem('enterprises', true, utils.getEnterpiseID()).then(response => {
        //       utils.setActiveEnterprise(this, response)
        //     })
        //   } else {
        //     this.$router.push('/dashboard')
        //   }
        // }
      },
      getUserInfo () {
        this.$store.state.app.enterpriseID = utils.getEnterpiseID()
        api.getItem('enterprises', true, utils.getEnterpiseID()).then(response => {
          this.$store.state.app.enterpriseName = response.Name 
        })
        const userID = utils.getUserID()
        if (!userID || userID.length <= 0) {
          this.$router.push('/login')
        } else {
          api.getItem('users', true, userID).then(response => {
            this.$store.state.app.userID = response.ID
            this.$store.state.app.isAdmin = response.Role === constants.roles.admin ? true : false
            this.$store.state.app.userName = response.Name
            if (!this.$store.state.app.isAdmin && response.Enterprises.length === 0) {
              console.log(this.$store.state.app.isAdmin, response)
              this.$router.push('/login')
            }
            this.getEnterpriseInfo(response.Enterprises, response.EnterpriseDefault)
            this.loading = false
          })
        }
      }
    }
  }
</script>
<style lang="scss">
  h1 {
    font-weight: normal;
  }
  .sidebar {
    float: left;
  }
  .main-body {
    // margin-left:80px;
  }
  // @import '@/styles/index.scss';

  // /* Remove in 1.2 */
  // .v-datatable thead th.column.sortable i {
  //   vertical-align: unset;
  // }
  // body {
  //   background-color:#eee;
  // }
</style>
